import { Controller } from "@hotwired/stimulus"

// The contact form's email field: on blur, ask the doors' address check and
// say before the save what will happen (red: bounced, refused at save;
// amber: unsubscribed, saved but never mailed). Nothing for a clean address.
export default class extends Controller {
  static targets = ["input", "line"]
  static values = { url: String }

  async check() {
    const email = this.inputTarget.value.trim()
    if (!email || !email.includes("@")) { this.paint(null); return }
    // An unchanged address on the edit form is not re-checked at save; say nothing.
    if (email === (this.inputTarget.defaultValue || "").trim()) { this.paint(null); return }
    try {
      const res = await fetch(`${this.urlValue}?email=${encodeURIComponent(email)}`, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!res.ok) return
      this.paint(await res.json())
    } catch (e) { /* the save says it anyway */ }
  }

  paint(n) {
    if (!this.hasLineTarget) return
    if (!n || !n.word) { this.lineTarget.hidden = true; this.lineTarget.textContent = ""; return }
    const red = n.word === "bounced"
    this.lineTarget.className = `text-xs mt-1 ${red ? "text-[var(--color-status-declined)]" : "text-[var(--color-status-pending)]"}`
    this.lineTarget.textContent = red
      ? "Bounced before. It will be refused at save; you can verify it again there."
      : "This person has unsubscribed in the past and will not be allowed to receive emails."
    this.lineTarget.hidden = false
  }
}
